import React from 'react'

import { Box, Color, FontWeight, Space, Text } from '@gousto-internal/citrus-react'

import type { RecipeSubtitleItem } from '@features/recipe-tile/src/components/RecipeSubtitle'
import { RecipeSubtitleItems } from '@features/recipe-tile/src/components/RecipeSubtitle'
import type { DisplayPreference } from '@library/api-menu-experience'

type RecipeInformationPreviewProps = {
  displayPreferences: DisplayPreference[]
}

const PREVIEW_IMAGE_HEIGHT = '180px'
const PREVIEW_BODY_MIN_HEIGHT = '100px'

const displayPreferenceTypeToFooterIconType: Partial<
  Record<DisplayPreference['type'], NonNullable<RecipeSubtitleItem['iconType']>>
> = {
  ratings: 'rating',
  'spice-level': 'spice',
}

export const RecipeInformationPreview = ({ displayPreferences }: RecipeInformationPreviewProps) => {
  const previewItems = displayPreferences.reduce<RecipeSubtitleItem[]>((items, preference) => {
    if (!preference.selected || !preference.example) {
      return items
    }

    return [
      ...items,
      {
        type: preference.type,
        text: preference.example,
        accessibleText: preference.example,
        iconType: displayPreferenceTypeToFooterIconType[preference.type],
      },
    ]
  }, [])

  return (
    <Box
      bg={Color.White}
      data-testid="recipe-information-preview"
      style={{
        borderRadius: '4px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
      }}
    >
      <Box bg={Color.ColdGrey_100} height={PREVIEW_IMAGE_HEIGHT} />
      <Box minHeight={PREVIEW_BODY_MIN_HEIGHT} paddingH={3} paddingV={3}>
        <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={4}>
          Recipe name
        </Text>
        {previewItems.length ? (
          <>
            <Space size={1} direction="vertical" />
            <RecipeSubtitleItems items={previewItems} />
          </>
        ) : null}
      </Box>
    </Box>
  )
}
